import m from "mithril";
import Requester from "../../../shared/request";
import Gateway from "../../../shared/app_settings";
import i18n from "../../../shared/i18n/i18n";
import Toasts from "../../../shared/toasts";
import SessionController from "../../../shared/session";
import ScormUtilities from "../../../shared/utilities/scorm_utilities";

let loading = false;
let unit = null;
let previewUnit = null;

function loadUnit() {
    loading = true;
    Requester.get(Gateway.admin + "units/" + unit.id)
        .then(function (result) {
            previewUnit = null;
            previewUnit = result.properties;
        })
        .catch(function (error) {
            Toasts.add("error", i18n.t("error"), i18n.t(error.response.properties.errorCode));
        })
        .then(function () {
            loading = false;
        });
}

function useModernPlayer() {
    return ScormUtilities.useModernPlayer();
}

let closeCallback;
const Component_Unit_Scorm_Preview = {
    oninit: function (vnode) {
        unit = vnode.attrs.unit;
        loadUnit();
        closeCallback = vnode.attrs.closeCallback;
    },
    onremove: function () {
        unit.selected = false;
    },
    view: function (vnode) {
        const storageUrl = SessionController.session.environment.storageUrl;
        const previewPlayerFile = useModernPlayer()
            ? storageUrl + "/scorm-player/scorm_preview_player_v2.html"
            : storageUrl + "/scorm-player/scorm_preview_player.html";

        return [
            m(".flex-auto", [
                !loading ?
                    m(".scorm-preview", previewUnit && previewUnit.scormSource ?
                        m("iframe", {
                            src: previewPlayerFile,  // Player from storage domain (same-origin as content)
                            onload: function () {
                                const targetOrigin = storageUrl;

                                this.contentWindow.postMessage({
                                    method: "activate",
                                    data: {source: previewUnit.scormSource, version: previewUnit.scormVersion}
                                }, targetOrigin)
                            }
                        })
                        : m(".content-box flex-auto", i18n.t("cant_load"))
                    )
                    : [i18n.t("loading"), m(".loading-dots")]
            ])
        ];
    }
};
export default Component_Unit_Scorm_Preview;
